import React from 'react';

import { useTranslation } from 'react-i18next';

import { CustomModal, Flex, UiButton, UiText } from '@shared/ui';
import { Loader } from '@shared/ui/CustomModal/ui/Loader/Loader';

import cls from './ModalAddManagerInfo.module.css';
import { ModalBodyAddManagerInfo } from './ModalBodyAddManagerInfo/ModalBodyAddManagerInfo';
import { useModalAddManagerInfo } from './useModalAddManagerInfo';

interface ModalAddManagerInfoProps {
    classes?: string;
}

export const ModalAddManagerInfo = ({ classes }: ModalAddManagerInfoProps) => {
    const { modalMode, onCancel, onForm, form, onSubmit, errorsMessage, modalLoader } =
        useModalAddManagerInfo();

    const { t } = useTranslation();

    return (
        <CustomModal
            contentClasses={cls.ModalAddManagerInfo}
            isOpen={modalMode === 'addManager'}
            onHideModal={onCancel}
        >
            {modalLoader && <Loader variant="light" />}
            <CustomModal.Header classes={cls.modalHeader}>
                <Flex direction="column" align="start" gap={10}>
                    {t('ModalAddManagerInfo.return.modalHeader')}

                    <div className={cls.subtitle}>
                        <UiText variant="mediumPlain">
                            {t('ModalAddManagerInfo.return.modalHeader.subtitle')}
                        </UiText>
                    </div>
                </Flex>
            </CustomModal.Header>
            <CustomModal.Body>
                <ModalBodyAddManagerInfo form={form} onForm={onForm} errors={errorsMessage} />
            </CustomModal.Body>
            <CustomModal.Footer>
                <Flex fullWidth justify="between">
                    <UiButton
                        btnColor="secondary"
                        onClick={onCancel}
                        btnText={t('ModalAddManagerInfo.return.modalFooter.cancel')}
                    />
                    <UiButton
                        onClick={onSubmit}
                        btnText={t('ModalAddManagerInfo.return.modalFooter.submit')}
                    />
                </Flex>
            </CustomModal.Footer>
        </CustomModal>
    );
};
